if(!customElements.get('blog-carousel')) {
    class BlogCarousel extends HTMLElement {
        constructor() {
            super();

            this.carousel = this.querySelector('swiper-container');
            
        }

        connectedCallback() {
            this.addCarouselParameters();

            setTimeout(() => {
                this.classList.remove('blog__carousel--no-transition');
            }, 1000);
        }

        addCarouselParameters() {
            Object.assign(this.carousel, {
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                grabCursor: true,                 
                pagination: {
                    el: '.blog__carousel-dots',
                    clickable: true
                },
                breakpoints: {
                    768: {
                        loop: true,
                        spaceBetween: 0, 
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        centeredSlides: true,   
                        centerInsufficientSlides: true
                    }
                },
                on: {
                    beforeInit: (swiper) => {
                      swiper.classNames.push('swiper-zoom');
                      swiper.classNames.push('swiper-3d');
                      Object.assign(swiper.params, {
                        watchSlidesProgress: !0
                      });
                      Object.assign(swiper.originalParams, {
                        watchSlidesProgress: !0
                      });
                  },
                  progress: (swiper) => {
                    let sizes = swiper.slidesSizesGrid,
                        grid = swiper.slidesGrid;

                    for (let n = 0; n < swiper.slides.length; n++) {
                        let slide = swiper.slides[n],
                            progress = Math.abs(slide.progress) * 0.15,
                            diff = 1 - progress,
                            scale = (diff < 0.85) ? 0.85 : diff,
                            delta_x = sizes[n] - sizes[n] * scale,
                            x = swiper.slidesGrid[n]/delta_x * progress;
                        slide.style.transform = `scale(${scale})`;
                    }
                  }
                }
            }); 
            
            this.carousel.initialize();
        }
    } 

    customElements.define('blog-carousel', BlogCarousel);
}